import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';

import { Typography } from '@/ui';

import AnswerDelta from './AnswerDelta';

import type { PulseReportDelta } from './deltaTypes';
import type { PulseReportAnswer } from '@/types';
import type { FC } from 'react';

interface AnswerRating5Props {
  answer: Extract<PulseReportAnswer, { kind: 'rating5' }>;
  delta?: PulseReportDelta;
}

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty': {
    color: theme.palette.text.disabled,
  },
  '& .MuiRating-iconFilled': {
    color: theme.palette.secondary.main,
  },
}));

const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

const formatPrompt = (prompt: string, max: number) => {
  const suffix = `(0-${max})`;
  return prompt.includes(suffix) ? prompt : `${prompt} ${suffix}`;
};

const AnswerRating5: FC<AnswerRating5Props> = ({ answer, delta }) => {
  const iconCount = Math.max(answer.max, 1);
  const value = clamp(answer.value, 0, iconCount);

  return (
    <div className="flex flex-col gap-2">
      <Typography className="text-cement-600" variant="subtitle1">
        {formatPrompt(answer.prompt, iconCount)}
      </Typography>
      <div className="flex items-center gap-2.5">
        <StyledRating
          data-testid="rating-stars"
          max={iconCount}
          value={value}
          readOnly
        />
        {delta ? <AnswerDelta delta={delta} /> : null}
      </div>
    </div>
  );
};

export default AnswerRating5;
